var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2748 15.0565C26.7955 15.5772 26.7955 16.4215 26.2748 16.9422L18.2748 24.9422C17.7541 25.4629 16.9099 25.4629 16.3892 24.9422C15.8685 24.4215 15.8685 23.5772 16.3892 23.0565L22.1131 17.3327L6.66536 17.3327C5.92898 17.3327 5.33203 16.7357 5.33203 15.9993C5.33203 15.263 5.92898 14.666 6.66536 14.666L22.1131 14.666L16.3892 8.94216C15.8685 8.42146 15.8685 7.57724 16.3892 7.05654C16.9099 6.53584 17.7541 6.53584 18.2748 7.05654L26.2748 15.0565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPromo);
export default __webpack_public_path__ + "static/media/arrow-right-promo.2b31ff193e116c265d8ec72e821e2b05.svg";
export { ForwardRef as ReactComponent };